/**
 * 业务工具
 */

import toolCommon from './plugins';
let vue;
/**
 * 上传文件
 * @param {*} file 文件file / base64串
 * @param {*} ext 文件后缀
 */
async function uploadFile(file, ext, ossParams) {
  if (!ext) {
    ext = 'png';
  }
  // if (!vue.$store.state.ossClient) {
  //   return vue.$error("OSS 未初始化，请联系管理员配置");
  // }
  // if (typeof file == "string") {
  //   file = toolCommon.dataURLtoFile(file);
  // }
  // let filename =
  //   "/uploads/files/" +
  //   new Date().format("yyyyMMdd") +
  //   "/" +
  //   Number(new Date()) +
  //   toolCommon.uuid(16);
  // if (ext) {
  //   filename += "." + ext;
  // }
  // vue.$store.commit("setLoading", true);
  // const result = await vue.$store.state.ossClient.put(filename, file);
  // vue.$store.commit("setLoading", false);
  if (!ossParams) {
    return vue.$Message.error('OSS 未初始化，请联系管理员配置');
  }
  if (typeof file == 'string') {
    file = toolCommon.dataURLtoFile(file);
  }
  let filename = ossParams.dir + toolCommon.uuid(16);
  if (ext) {
    filename += '.' + ext;
  }
  let formData = new FormData();
  formData.append('key', `${filename}`);
  formData.append('success_action_status', 200); // 让服务端返回200，不设置则默认返回204。
  formData.append('OssAccessKeyId', ossParams.accessid);
  formData.append('policy', ossParams.policy);
  formData.append('signature', ossParams.signature);
  formData.append('callback', ossParams.callback);
  formData.append('file', file); // 必须放在最后
  // 发送 POST 请求
  const result = await vue.$http.post(ossParams.host, formData, {
    fullUrl: true,
  });
  return {
    ext,
    type: file.type,
    size: file.size,
    originalName: file.name,
    path: result.url,
  };
}
export function use(vueInstance) {
  vue = vueInstance;
}

function uploadAnyFile(accept = '') {
  return new Promise((resolve) => {
    let file = document.createElement('input');
    file.type = 'file';
    file.accept = accept;
    file.onchange = async function () {
      if (file.files.length == 0) {
        return;
      }
      let names = file.files[0].name.split('.');
      let data = await uploadFile(file.files[0], names[names.length - 1]);
      resolve(data);
    };
    file.click();
  });
}

function uploadImage() {
  return uploadAnyFile('image/*');
}

export default {
  uploadFile,
  uploadAnyFile,
  uploadImage,
};
